import React, {useEffect, useState} from "react";
import axios from "axios";
import {useMediaQuery} from "beautiful-react-hooks";
import { toast } from "react-toastify";
import { useAuthState } from "../../Context/auth-context";
import moment from "jalali-moment";



const Pr = {
    "buy":"خرید",
    "sell": "فروش"
}

export default function OrdersDetails ({phone,auth=''}){
    const [listorders,setListOrders] = useState([])
    const isSmall = useMediaQuery('(max-width: 768px)')
    const {isAuth} =  useAuthState()
    const {loading} =  useAuthState()
    const [active,setActive] = useState('done')
    const [OpenOrders,setOpenOrders] = useState([])
    const [OpenSpotOrders,setOpenSpotOrders] = useState([])

    



    


    function handleReject(event){
        console.log(event.target.id)
        var id = event.target.id

        axios.post('https://api.sinatether.com/Auth/request_reject/',{
            'id':id,

        },{
            withCredentials:true
        }).then((res)=>{

            if(res.status == 200){

                if (res.data['status'] == 200){
                    toast.success(res.data['message'])
                }else{
                    toast.error(res.data['message'])

                }
            }


        })



    }



    useEffect(()=>{
        axios.get('https://api.sinatether.com/Auth/GetOdersUser/',{
            params: {"phone":phone},
            withCredentials:true
        

        }).then((res)=>{
            if(res.status == 200){


                setListOrders(res.data['listOrders'])
                setOpenOrders(res.data['open_orders'])
                setOpenSpotOrders(res.data['open_spot_orders'])
            }

        }).catch((error)=>{
            if (error){
                if (error.response.status === 400){
                    toast.dismiss()
                    toast.error("نشست شما منقضی شده است مجددا وارد شوید")
                }

            }
        })
    },[])



    return(
        <>

                            <div className={''}>


                                        <div className={''}>
                                   <div className={''}>

                        <div className={'head_29540 padd-title text-center '}>

                            <div className="text-title-report">

                            تاریخچه سفارشات شما


                            </div>

                        </div>

                        <div className="tabs7642">
                    <div className={active == 'done'? 'item7642 item7642-active': 'item7642'} onClick={()=>setActive('done')}>
                        سفارشات انجام شده

                    </div>
                    <div className={active == 'open'? 'item7642 item7642-active': 'item7642'} onClick={()=>setActive('open')}>
                        سفارشات باز 

                    </div>
                 

                </div>



                        {isSmall   ? 




<div className={'listContent__29514 orderdet'}>
<div className="tableHeader__29540  bt-0">
    <div className={'col-3 text-normal pl-2'}>نوع</div>
    <div className={'col-3 text-normal pl-0'}>نام کوین</div>
    <div className={'col-3 text-normal pl-0'}>مقدار</div>
    <div className={'col-3 text-normal pl-0'}> مبلغ کل</div>


</div>
{auth ?

<>


    <div className={'listcoinTable fksjfus63hh55'}>


        {active == 'done'? 
        <>


        {listorders ?

            <>


                {
                    listorders.map((lior) =>

                    <div className= {`accordion-item ${lior['side'] == "buy"? 'sucess-box' : 'danger-box'} `}>
<h2 className="accordion-header danger-box " id={`heading${lior['id']}`}>
    <button className={`accordion-button   pt-0 pb-0 collapsed pr-12 ${lior['side'] == "buy"? 'sucess-box' : 'danger-box'}  `} type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${lior['id']}`}
            aria-expanded="true"
            aria-controls={`collapse${lior['id']}`}>


<div className={'row itemCoins  w-100 titem2020  '} >
                                <div className={'col-3 text-right'}>
                                {lior['side'] == "buy"?
                                                        <span className={'text-normal  text-success'}>خریده شده</span>
                                                        :

                                                        <span className={'text-normal  text-danger'}>فروخته شده</span>




                                    }
                                </div>
                                <div className={'col-3 pr-0 pl-0 text-right'}>

                                    <span
                                        className={'text-normal pl-1 '}>{lior['symbol']}</span>

                                </div>
                                <div className={'col-3 pr-0 pl-0 text-right '}>
                                    <span
                                        className={'text-normal  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['size'])}</span>

                                </div>


                                <div className={'col-3 pr-0 pl-0  text-right'}>
                                    <span
                                        className={'text-normal  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['priceWithKarmozd'])}</span>

                                </div>

                                </div>

  


    </button>
</h2>
<div id={`collapse${lior['id']}`}
     className="accordion-collapse collapse "
     aria-labelledby={`heading${lior['id']}`}
     data-bs-parent="#accordionExample">
    <div className="accordion-body kfjhsygbehbrhegrter padding-0">

        <div className="djsdhfyytrgsgfvsaacc">

            <div className="row pb-1">

                <div className="col-6">
                <div className={'row'}>
                                    <div className={'col-6 '}>
                                        <span className={'text-normal text-dark '}>
                                            مبلغ معامله:
                                        </span>

                                    </div>
                                    <div className={'col-6 pl-0 pr-0'}>
                                        <span className={' text-normal text-content'}>
                                            {new Intl.NumberFormat("fa",{maximumFractionDigits:2}).format(lior['price'])}
                                        </span>

                                    </div>

                                </div>



                </div>


                <div className="col-6">
                <div className="row">
                                    <div className="col-6 pl-0 pr-0"><span className="text-normal text-dark ">قیمت ارز:</span></div><div class="col-6 pl-0 pr-0">
                                {lior['price_coin']?

                                    <span className=" text-normal text-content">
                                {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['price_coin'])}
                                    </span>

                                    :
                                    <span class=" text-normal text-normal text-content"> --- </span>

                                    }
                                    
                                    </div></div>
                    
                    </div>

            </div>


            <div className="row">

            <div className="col-6">

            <div className="row"><div className="col-6 "><span className="text-normal text-dark ">قیمت تتر:</span></div><div className="col-6 pl-0 pr-0">
                                    {lior['teter_price']?
                                    <span class=" text-normal text-content"> 
                                                                           {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['teter_price'])}
                                    </span>

                                    :
                                    <span class="text-normal text-content"> --- </span>

                                }
                                    
                                    
                                    
                                    </div></div>
                    
                    </div>



                    <div className="col-6">

                        
                    <div className={'row'}>
                                    <div className={'col-4 pl-0 pr-0'}>
                                        <span className={'text-normal  text-dark '}>
                                            تاریخ:
                                        </span>

                                    </div>
                                    <div className={'col-8 pl-0 pr-0'}>
                                        <div
                                    className={'mynumber text-content mynorm-text   text-right'}>{
                                        moment(lior['date'], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')

                                                 }
                                                 {lior['dateTime'].split('.')[0] ?
                                                             <span className="pr-1 mynumber text-content mynorm-text " >
                                                                 {lior['dateTime'].split('.')[0]}

                                                            </span>

                                                            :
                                                            <span className="pr-1 mynumber text-content mynorm-text " >
                                                                 {lior['dateTime']}

                                                            </span>
                                                            

                                                           }


         </div>

                                    </div>

                                </div>
                    
                    </div>

            </div>


 
                              

                                




    </div>




    </div>
</div>
</div>




                          




                         









                          
                    )
                }
            </>

            :
            <div className={'text-center mt-5 pt-5'}>
                <span
                    className={'text-muted'}>هیچ سفارشی وجود ندارد</span>
            </div>

        }
        </>

        :



        <>


        {OpenOrders ?

            <>


                {
                    OpenOrders.map((lior) =>

                    <div className= {`accordion-item ${lior['side'] == "buy"? 'sucess-box' : 'danger-box'} `}>
<h2 className="accordion-header danger-box " id={`heading${lior['id']}`}>
    <button className={`accordion-button   pt-0 pb-0 collapsed pr-12 ${lior['side'] == "buy"? 'sucess-box' : 'danger-box'}  `} type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${lior['id']}`}
            aria-expanded="true"
            aria-controls={`collapse${lior['id']}`}>


<div className={'row itemCoins  w-100 titem2020  '} >
                                <div className={'col-3 text-right'}>
                                {lior['side'] == "buy"?
                                                        <span className={'text-normal  text-success'}> خرید </span>
                                                        :

                                                        <span className={'text-normal  text-danger'}> فروش</span>




                                    }
                                </div>
                                <div className={'col-3 pr-0 pl-0 text-right'}>

                                    <span
                                        className={'text-normal pl-1 '}>{lior['symbol']}</span>

                                </div>
                                <div className={'col-3 pr-0 pl-0 text-right '}>
                                    <span
                                        className={'text-normal  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['size'])}</span>

                                </div>


                                <div className={'col-3 pr-0 pl-0  text-right'}>
                                    <span
                                        className={'text-normal  text-right'}>

                                                <button id={lior['id']} className="btn131424242-danger" onClick={handleReject}>
                                                        لغو درخواست 
                                                    </button>
                                        </span>

                                </div>

                                </div>

  


    </button>
</h2>
<div id={`collapse${lior['id']}`}
     className="accordion-collapse collapse "
     aria-labelledby={`heading${lior['id']}`}
     data-bs-parent="#accordionExample">
    <div className="accordion-body kfjhsygbehbrhegrter padding-0">

        <div className="djsdhfyytrgsgfvsaacc">

            <div className="row pb-1">

                <div className="col-6">
                <div className={'row'}>
                                    <div className={'col-6 '}>
                                        <span className={'text-normal text-dark '}>
                                            مبلغ معامله:
                                        </span>

                                    </div>
                                    <div className={'col-6 pl-0 pr-0'}>
                                        <span className={' text-normal text-content'}>
                                            {new Intl.NumberFormat("fa",{maximumFractionDigits:2}).format(lior['price'])}
                                        </span>

                                    </div>

                                </div>



                </div>


                <div className="col-6">
                <div className="row">
                                    <div className="col-6 pl-0 pr-0"><span className="text-normal text-dark ">قیمت مشخص:</span></div><div class="col-6 pl-0 pr-0">
                                {lior['target_price']?

                                    <span className=" text-normal text-content">
                                {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['target_price'])}
                                    </span>

                                    :
                                    <span class=" text-normal text-normal text-content"> --- </span>

                                    }
                                    
                                    </div></div>
                    
                    </div>

            </div>


            <div className="row">

            <div className="col-6">

            <div className="row"><div className="col-6 "><span className="text-normal text-dark ">قیمت تتر:</span></div><div className="col-6 pl-0 pr-0">
                                    {lior['teter_price']?
                                    <span class=" text-normal text-content"> 
                                                                           {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['teter_price'])}
                                    </span>

                                    :
                                    <span class="text-normal text-content"> --- </span>

                                }
                                    
                                    
                                    
                                    </div></div>
                    
                    </div>



                    <div className="col-6">

                        
                    <div className={'row'}>
                                    <div className={'col-4 pl-0 pr-0'}>
                                        <span className={'text-normal  text-dark '}>
                                            تاریخ:
                                        </span>

                                    </div>
                                    <div className={'col-8 pl-0 pr-0'}>
                                        <div
                                    className={'mynumber text-content mynorm-text   text-right'}>{
                                        moment(lior['date'], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')

                                                 }
                                                 {lior['dateTime'].split('.')[0] ?
                                                             <span className="pr-1 mynumber text-content mynorm-text " >
                                                                 {lior['dateTime'].split('.')[0]}

                                                            </span>

                                                            :
                                                            <span className="pr-1 mynumber text-content mynorm-text " >
                                                                 {lior['dateTime']}

                                                            </span>
                                                            

                                                           }


         </div>

                                    </div>

                                </div>
                    
                    </div>

            </div>


 
                              

                                




    </div>




    </div>
</div>
</div>




                          




                         









                          
                    )
                }
            </>

            :
            <div className={'text-center mt-5 pt-5'}>
                <span
                    className={'text-muted'}>هیچ سفارشی وجود ندارد</span>
            </div>

        }


        
{OpenSpotOrders ?

<>


    {
        OpenSpotOrders.map((lior) =>

        <div className= {`accordion-item ${lior['side'] == "buy"? 'sucess-box' : 'danger-box'} `}>
<h2 className="accordion-header danger-box " id={`heading${lior['id']}`}>
<button className={`accordion-button   pt-0 pb-0 collapsed pr-12 ${lior['side'] == "buy"? 'sucess-box' : 'danger-box'}  `} type="button"
data-bs-toggle="collapse"
data-bs-target={`#collapse${lior['id']}`}
aria-expanded="true"
aria-controls={`collapse${lior['id']}`}>


<div className={'row itemCoins  w-100 titem2020  '} >
                    <div className={'col-3 text-right'}>
                    {lior['side'] == "buy"?
                                            <span className={'text-normal  text-success'}> خرید </span>
                                            :

                                            <span className={'text-normal  text-danger'}> فروش</span>




                        }
                    </div>
                    <div className={'col-3 pr-0 pl-0 text-right'}>

                        <span
                            className={'text-normal pl-1 '}>{lior['symbol']}</span>

                    </div>
                    <div className={'col-3 pr-0 pl-0 text-right '}>
                        <span
                            className={'text-normal  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['size'])}</span>

                    </div>


                    <div className={'col-3 pr-0 pl-0  text-right'}>
                        <span
                            className={'text-normal  text-right'}>

                                    <button id={lior['id']} className="btn131424242-danger" onClick={handleReject}>
                                            لغو درخواست 
                                        </button>
                            </span>

                    </div>

                    </div>




</button>
</h2>
<div id={`collapse${lior['id']}`}
className="accordion-collapse collapse "
aria-labelledby={`heading${lior['id']}`}
data-bs-parent="#accordionExample">
<div className="accordion-body kfjhsygbehbrhegrter padding-0">

<div className="djsdhfyytrgsgfvsaacc">

<div className="row pb-1">

    <div className="col-6">
    <div className={'row'}>
                        <div className={'col-6 '}>
                            <span className={'text-normal text-dark '}>
                                حد سود:
                            </span>

                        </div>
                        <div className={'col-6 pl-0 pr-0'}>
                            <span className={' text-normal text-content'}>
                                بیشتر از
                                {new Intl.NumberFormat("fa",{maximumFractionDigits:2}).format(lior['benefit'])}
                                درصد
                            </span>

                        </div>

                    </div>



    </div>


    <div className="col-6">
    <div className="row">
                        <div className="col-6 pl-0 pr-0"><span className="text-normal text-dark ">حد ضرر :</span></div><div class="col-6 pl-0 pr-0">
                    {lior['loss']?

                        <span className=" text-normal text-content">
                            بیشتر از 
                    {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['loss'])}
                    درصد
                        </span>

                        :
                        <span class=" text-normal text-normal text-content"> --- </span>

                        }
                        
                        </div></div>
        
        </div>

</div>


<div className="row">

<div className="col-6">

<div className="row"><div className="col-6 "><span className="text-normal text-dark ">قیمت تتر:</span></div><div className="col-6 pl-0 pr-0">
                        {lior['teter_price']?
                        <span class=" text-normal text-content"> 
                                                               {new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['teter_price'])}
                        </span>

                        :
                        <span class="text-normal text-content"> --- </span>

                    }
                        
                        
                        
                        </div></div>
        
        </div>



        <div className="col-6">

            
        <div className={'row'}>
                        <div className={'col-4 pl-0 pr-0'}>
                            <span className={'text-normal  text-dark '}>
                                تاریخ:
                            </span>

                        </div>
                        <div className={'col-8 pl-0 pr-0'}>
                            <div
                        className={'mynumber text-content mynorm-text   text-right'}>{
                            moment(lior['date'], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')

                                     }
                                     {lior['dateTime'].split('.')[0] ?
                                                 <span className="pr-1 mynumber text-content mynorm-text " >
                                                     {lior['dateTime'].split('.')[0]}

                                                </span>

                                                :
                                                <span className="pr-1 mynumber text-content mynorm-text " >
                                                     {lior['dateTime']}

                                                </span>
                                                

                                               }


</div>

                        </div>

                    </div>
        
        </div>

</div>



                  

                    




</div>




</div>
</div>
</div>




              




             









              
        )
    }
</>

:
<div className={'text-center mt-5 pt-5'}>
    <span
        className={'text-muted'}>هیچ سفارشی وجود ندارد</span>
</div>

}




        </>


    }





    </div>

    </>


    :

    <div className={'text-center w-100 mt-5 mb-5'}>

        <a href={'/login'} className={'text-center'}>
            <button
                className={'btn btn-primary  text-large px-2 py-2 '}>ورود
                | ثبت نام
            </button>
        </a>

    </div>


}

</div>




                          :


                        <div className={'listContent__29514'}>
                            <div className="tableHeader__29540 bt-0 ">
                                <div className={'col text-normal'}>نوع</div>
                                <div className={'col text-normal'}>نام کوین</div>
                                 <div className={'col text-normal'}>مقدار</div>
                                <div className={'col text-normal'}>مبلغ معامله شده</div>
                                <div className={'col text-normal'}> مبلغ کل</div>

                                <div className={'col text-normal'}>
                                    {active == 'done' ? 
                                    <>
                                                                        قیمت ارز

                                    </>
                                    :
                                    <>
                                    قیمت مشخص

                                    </>



                                    
                                
                                }
                                </div>
                                <div className={'col text-normal'}> 



                                {active == 'done' ? 
                                    <>
                                                                        قیمت تتر

                                    </>
                                    :
                                    <>

                                    تاریخ

                                    </>



                                    
                                
                                }


                                
                                
                                
                                </div>


                                <div className={'col text-normal'}>

                                {active == 'done' ? 
                                    <>
                                                                       تاریخ

                                    </>
                                    :
                                    <>


                                    </>



                                    
                                
                                }
                                    
                                    
                                    
                                     </div>




                            </div>
                            {!loading?
                                isAuth ?

                                <div className={'listcoinTable  orderdet'}>


                                {active == 'done'? 



                                    listorders ?

                                        <>


                                        {
                                            listorders.map((lior) =>



                                                <div className={`row itemCoins titem2020 plr16 ${lior['side'] == "buy"? 'sucess-box' : 'danger-box'}`}>
                                                    <div className={'col'}>
                                                        {lior['side'] == "buy"?
                                                        <span className={'text-medium pr-1 text-white pl-3 pr-3 bsucesskrng'}>خریده شده</span>
                                                        :

                                                        <span className={'text-medium pr-1  text-white pl-3 pr-3 bdjanger23435'}>فروخته شده</span>




                                                      }
                                                    </div>
                                                    <div className={'col pr-0 pl-0'}>

                                                        <span className={'text-large'}>{lior['symbol']}</span>

                                                    </div>
                                                    <div className={'col pr-0 pl-0 '}>
                                                        <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['size'])}</span>

                                                    </div>


                                                    <div className={'col pr-0 pl-0 '}>
                                                        <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['price'])}</span>

                                                    </div>


                                                    <div className={'col pr-0 pl-0 '}>
                                                        <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['priceWithKarmozd'])}</span>

                                                    </div>
                                                    <div className={'col pr-0 pl-0 '}>
                                                        {lior['price_coin'] ?
                                                        <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['price_coin'])}</span>

                                                        :
                                                        <span className={'text-large  text-right'}>---</span>

                                                    }




                                                    </div>



                                                    <div className={'col pr-0 pl-0 '}>
                                                        {lior['teter_price'] ?
                                                        <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['teter_price'])}</span>

                                                        :
                                                        <span className={'text-large  text-right'}>---</span>

                                                    }




                                                    </div>



                                                    <div className={'col pr-0 pl-0 '}>
                                                        <span
                                                            className={'text-large text-dark  text-right'}>{
                                                                moment(lior['date'], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')

                                                            }
                                                           

                                                            {lior['dateTime'].split('.')[0] ?
                                                             <span className="pr-1 text-large text-dark" >
                                                                 {lior['dateTime'].split('.')[0]}

                                                            </span>

                                                            :
                                                            <span className="pr-1 text-large text-dark" >
                                                                 {lior['dateTime']}

                                                            </span>
                                                            

                                                           }


                                                        </span>

                                                    </div>

                                                </div>
                                            )
                                        }
                                         </>

                                        :
                                        <div className={'text-center mt-5 pt-5'}>
                                            <span className={'text-muted'}>هیچ سفارشی وجود ندارد</span>
                                        </div>

                                    

                                :

                                <>

                                
                               {OpenOrders ?

                                    <>


                                    {
                                        OpenOrders.map((lior) =>



                                            <div className={`row itemCoins titem2020 plr16 ${lior['side'] == "buy"? 'sucess-box' : 'danger-box'}`}>
                                                <div className={'col'}>
                                                    {lior['side'] == "buy"?
                                                    <span className={'text-medium pr-1 text-white pl-3 pr-3 bsucesskrng'}> خرید</span>
                                                    :

                                                    <span className={'text-medium pr-1  text-white pl-3 pr-3 bdjanger23435'}>  فروش</span>




                                                  }
                                                </div>
                                                <div className={'col pr-0 pl-0'}>

                                                    <span className={'text-large'}>{lior['symbol']}</span>

                                                </div>
                                                <div className={'col pr-0 pl-0 '}>
                                                    <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['size'])}</span>

                                                </div>


                                                <div className={'col pr-0 pl-0 '}>
                                                    <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['price'])}</span>

                                                </div>


                                                <div className={'col pr-0 pl-0 '}>
                                                    <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['priceWithKarmozd'])}</span>

                                                </div>
                                                <div className={'col pr-0 pl-0 '}>
                                                    {lior['target_price'] ?
                                                    <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['target_price'])}</span>

                                                    :
                                                    <span className={'text-large  text-right'}>---</span>

                                                }




                                                </div>



        



                                                <div className={'col pr-0 pl-0 '}>
                                                    <span
                                                        className={'text-large text-dark  text-right'}>{
                                                            moment(lior['date'], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')

                                                        }
                                                       

                                                        {lior['dateTime'].split('.')[0] ?
                                                         <span className="pr-1 text-large text-dark" >
                                                             {lior['dateTime'].split('.')[0]}

                                                        </span>

                                                        :
                                                        <span className="pr-1 text-large text-dark" >
                                                             {lior['dateTime']}

                                                        </span>
                                                        

                                                       }


                                                    </span>

                                                </div>


                                                <div className={'col pr-0 pl-0 '}>

                                                <button id={lior['id']} className="btn131424242-danger" onClick={handleReject}>
                                                        لغو درخواست 
                                                </button>
                          

                                                




                                                </div>

                                            </div>
                                        )
                                    }
                                     </>

                                    :
                                    <div className={'text-center mt-5 pt-5'}>
                                        <span className={'text-muted'}>هیچ سفارشی وجود ندارد</span>
                                    </div>

                                }



                                 
                               {OpenSpotOrders ?

                                    <>


                                    {
                                        OpenSpotOrders.map((lior) =>



                                            <div className={`row itemCoins titem2020 plr16 ${lior['side'] == "buy"? 'sucess-box' : 'danger-box'}`}>
                                                <div className={'col'}>
                                                    {lior['side'] == "buy"?
                                                    <span className={'text-medium pr-1 text-white pl-3 pr-3 bsucesskrng'}> خرید</span>
                                                    :

                                                    <span className={'text-medium pr-1  text-white pl-3 pr-3 bdjanger23435'}>  فروش</span>




                                                  }
                                                </div>
                                                <div className={'col pr-0 pl-0'}>

                                                    <span className={'text-large'}>{lior['symbol']}</span>

                                                </div>
                                                <div className={'col pr-0 pl-0 '}>
                                                    <span className={'text-large  text-right'}>{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(lior['size'])}</span>

                                                </div>


                                                <div className={'col pr-0 pl-0 '}>
                                                    <span className={'text-large  text-right'}>---</span>

                                                </div>


                                                <div className={'col pr-0 pl-0 '}>
                                                    <span className={'text-large  text-right'}>---</span>

                                                </div>
                                                <div className={'col pr-0 pl-0 '}>
                                                    <span className={'text-large  text-right'}>
                                                        حد سود
                                                        
                                                    {new Intl.NumberFormat("fa",{maximumFractionDigits:2}).format(lior['benefit'])}
                                                    %



                                                حد ضرر 


                                                    {new Intl.NumberFormat("fa",{maximumFractionDigits:2}).format(lior['benefit'])}
                                                    %



                                                
                                                
                                                </span>

                                                    


                                                </div>



        



                                                <div className={'col pr-0 pl-0 '}>
                                                    <span
                                                        className={'text-large text-dark  text-right'}>{
                                                            moment(lior['date'], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')

                                                        }
                                                       

                                                        {lior['dateTime'].split('.')[0] ?
                                                         <span className="pr-1 text-large text-dark" >
                                                             {lior['dateTime'].split('.')[0]}

                                                        </span>

                                                        :
                                                        <span className="pr-1 text-large text-dark" >
                                                             {lior['dateTime']}

                                                        </span>
                                                        

                                                       }


                                                    </span>

                                                </div>


                                                <div className={'col pr-0 pl-0 '}>

                                                <button id={lior['id']} className="btn131424242-danger" onClick={handleReject}>
                                                        لغو درخواست 
                                                </button>
                          

                                                




                                                </div>

                                            </div>
                                        )
                                    }
                                     </>

                                    :
                                    <div className={'text-center mt-5 pt-5'}>
                                        <span className={'text-muted'}>هیچ سفارشی وجود ندارد</span>
                                    </div>

                                }






                                
                                </>



                            }


                                










                                </div>



                                :

                                <div className={'text-center w-100 mt-5 mb-5'}>

                                    

                                    <a href={'/login'} className={'text-center'}>
                                        <button className={'btn btn-primary  text-large text-white px-2 py-2 '}>ورود | ثبت نام </button>
                                    </a>

                                </div>


                            :
                            <div className="text-center mt-5 mb-5">
                                                    <i className="fa fa-spinner fa-spin loadIcon " aria-hidden="true"></i>



                                </div>


                            }

                        </div>





                        }



                        </div>



                    </div>



                </div>




        </>
    )

}